import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// 组件
import { Page, Card, Tabs, Tooltip, Icon, BlockStack, Text } from '@shopify/polaris';
import MyKeywords from './components/MyKeywords';
import KeywordList from './components/KeywordList';
// import CountJumpServiceBanner from '../../../components/CountJumpServiceBanner';
import ToastFunc from '../../../components/ToastFunc';
// 样式+图标
import './index.css';
import SkeltonLoading from '../../../components/SkeltonLoading';
import { QuestionMarkInverseMajor } from "@shopify/polaris-icons";
//翻译包
import Language from '../../../i18n/Language';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language

class indexClass extends Component {

  state = {
    loadingPage: true,
    //选中tabs
    selected: 0,
    userServices: '',
    showBanner: true
  };

  shouldComponentUpdate(nextProps) {
    if(nextProps.userServices !== this.props.userServices) {
      this.setState({
        userServices: nextProps.userServices
      })
    }
    return true;
  }
  
  //提示弹窗
  toggleToast = (showToastText, showToastIserror) => {
    this.setState({
      showToast: false,
    }, () => {
      this.setState(({ showToast }) => ({
        showToast: !showToast,
        showToastText: showToastText,
        showToastIserror: showToastIserror
      }))
    })
  };

  componentDidMount() {
    // setTimeout(() => {
    //   this.setState({
    //     loadingPage: false
    //   })
    // }, 500);
  }

  handleTabChange = (selectedTabIndex) => {
    this.setState({
      selected: selectedTabIndex,
    });
  };

  show = () => {
    this.props.show()
  }

  loadingStatus = () => {
    this.setState({
      loadingPage: false,
    }, () => {
      this.props.setLoadingPageKL()
    })
  }

  render() {
    const {
      state: {
        selected,
      },
      handleTabChange,
      loadingStatus
    } = this;

    let tableContent = ""
    if (selected === 0) {
      tableContent = <KeywordList loadingStatus={loadingStatus} show={this.show} userServices={this.props.userServices} toggleToast={this.toggleToast} />
    } else if (selected === 1) {
      tableContent = <MyKeywords loadingStatus={loadingStatus} show={this.show} userServices={this.props.userServices} toggleToast={this.toggleToast} />
    }

    const pagesContent = <div className='KeywordsLibraryContent'>
      {tableContent}
    </div>;

    const tabs = [
      {
        id: "keyword-list",
        content: t("Keyword list"),
        accessibilityLabel: "All customers",
        panelID: "keyword-list-content",
      },
      {
        id: "my-keywords",
        content: t("My keywords"),
        panelID: "my-keywords-content",
      },
    ];

    const toastMarkup = this.state.showToast ? <ToastFunc content={this.state.showToastText} onDismiss={this.state.showToast} error={this.state.showToastIserror} /> : null;

    // const pageBanner = this.state.showBanner ? <div><CountJumpServiceBanner form={5} /><div className="halfspace"></div></div> : null;

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 最终内容
    var pageContentLast = <div style={{display: this.state.loadingPage ? 'none' : ''}}>
      <Page
        title={<div className='keyword_title' style={{ display: "flex", alignItems: "center"}}>
          <Text variant="headingMd" as="h2">{t("Keywords Library")}</Text>&nbsp;
          <Tooltip content={t("Manage and organize all relevant keywords to help you meet content goals.")}>
            {<Icon backdrop source={QuestionMarkInverseMajor} />}
          </Tooltip>
        </div>}
      >
        <title>SEOAnt - Keywords Library</title>
        <div className='KeywordsLibrary'>
          {/* {pageBanner} */}
          <Card>
            <BlockStack gap={400}>
              <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}></Tabs>
              {pagesContent}
            </BlockStack>
          </Card>
        </div>

        {/* 底部 */}
        {FooterHelpBox}

        {/* 通知 */}
        {toastMarkup}
      </Page>
    </div>
      
    const SkeltonLoadingPage = this.state.loadingPage ? <SkeltonLoading /> : null;

    return (
      <div className='KeywordsLibrary-page'>
        {pageContentLast}
        {SkeltonLoadingPage}
      </div>
    );
  }
}

export default withRouter(indexClass);